import React, { ReactNode } from 'react';
import '../AiBrunixPanel.css';

interface BrunixResponseProps {
  children: ReactNode;
  label?: string;
  noBubble?: boolean;
  hideLabel?: boolean;
}

export const BrunixResponse = ({ children, label = 'Emi_Response', noBubble = false, hideLabel = false }: BrunixResponseProps) => {
  return (
    <div className="ai-brunix-panel-response-container">
      {!hideLabel && <span className="ai-brunix-panel-response-label">{label}</span>}
      <div className={`ai-brunix-panel-response-bubble${noBubble ? ' ai-brunix-panel-response-bubble--transparent' : ''}`}>
        <div className="ai-brunix-panel-msg-text">
          {children}
        </div>
      </div>
    </div>
  );
};
